<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :setLoading="setLoading"
    :persistenceKey="'bill-of-materials-list'"
    :backButtonEnable="false"
    ref="bom-list"
    :gcPopupConfig="gcPopupConfig"
    :class="'bill-of-materials-list'"
  >
    <template #hiddencontent>
      <dx-tooltip :ref="tooltipPrimaryProductionRef" position="right">
        <div class="tooltipContent">
          <div>
            This is the Primary Production BOM for the associated product.
          </div>
        </div>
      </dx-tooltip>
      <dx-tooltip :ref="tooltipPrimaryPlanningRef" position="right">
        <div class="tooltipContent">
          <div>
            This is the Primary Planning BOM for the associated product.
          </div>
        </div>
      </dx-tooltip>

      <dx-tooltip :ref="tooltipHeaderSelectRef" position="right">
        <div class="tooltipContent">
          <div>
            Please, make sure to apply material filter before selecting all
            records.
          </div>
        </div>
      </dx-tooltip>
    </template>
    <template #popup>
      <GCCopyBOM
        :visible="getCopyBOMVisible"
        @setCopyBOMVisible="setCopyBOMVisible"
        @refreshList="refreshList"
        :popUpConfig="popUpConfig"
        :displayServerError="displayServerErrorOnTemplate"
        :showLoading="showLoading"
        :displayValidationSummary="displayValidationSummary"
        v-if="getCopyBOMVisible"
      />
    </template>
  </TransactionListTemplate>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "@/_mixins/data-grid.mixin";

import TransactionListTemplate from "../../../templates/transaction-list";
import ColumnWidth from "../../../_helpers/data-grid/ColumnWidth";
import DxTooltip from "devextreme-vue/tooltip";
import GCCopyBOM from "../../../popups/bill-of-materials/gc-popup-copy-bom.vue";
import { FeatureStorage } from "../../../_services/storage";
import { on } from "devextreme/events";
import { getFilteredValueByKey } from "../../../_helpers/templates/transaction-list";
import { BillOfMaterialsService } from "../../../_services/api/production/bill-of-materials.service";
import {
  BillOfMaterialsAllTabs,
  GetIndexByTabName,
} from "../../../_models/tabdata/production/bill-of-materials-all-tabs";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: {
    TransactionListTemplate,
    DxTooltip,
    GCCopyBOM,
  },
  data() {
    return {
      tooltipPrimaryProductionRef: "completeTooltip",
      tooltipPrimaryPlanningRef: "planningTooltip",
      tooltipHeaderSelectRef: "headerSelectTooltip",
      setLoading: false,
      CopyBOMVisible: false,
      popUpConfig: {},
      visibleRowCount: 0,
      substituteModel: {
        MaterialCode: undefined,
        NewMaterialCode: undefined,
      },
      NewMaterialUpdated: false,
      gcPopupVisible: false,
      materialFilterField: "MaterialCodeList",
    };
  },
  computed: {
    getCopyBOMVisible() {
      return this.CopyBOMVisible;
    },
    setScreenConfig() {
      var config = {
        title: "Bill of Materials",
        ScreenName: "Bill of Materials",
        exportFileName: "Bill of Materials List",
        selectedIndex: GetIndexByTabName("BOM List"),
        tabs: BillOfMaterialsAllTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "BomList",
              //   filter: [["Status", "=", "A"]],
              // sort: [{ selector: "BomCode", asc: true }],
              serverPaging: true,
              allowGrouping: false,
              postProcessCallback: (response) => {
                // Custom post-processing logic

                response.forEach((element) => {
                  element.Inactive = element.Status === "A" ? "N" : "Y";
                });

                return response;
              },
              key: ["RecordId", "BomCode"],
              fieldType: {
                RecordId: "Guid",
                BomCode: "String",
              },
              keyType: {
                Attribute01: "Guid",
                Attribute02: "Guid",
                Attribute03: "Guid",
                Attribute04: "Guid",
                Attribute05: "Guid",
                Attribute06: "Guid",
                Attribute07: "Guid",
                Attribute08: "Guid",
                Attribute09: "Guid",
                Attribute10: "Guid",
                Attribute11: "Guid",
                Attribute12: "Guid",
                Attribute13: "Guid",
                Attribute14: "Guid",
                Attribute15: "Guid",
                Attribute16: "Guid",
                Attribute17: "Guid",
                Attribute18: "Guid",
                Attribute19: "Guid",
                Attribute20: "Guid",
                RecordId: "Guid",
                BomCode: "String",
              },
            },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No BOM records",
                message: "Get Started, Add a BOM",
              },
            },
            options: {
              onCellPreparedCallBack: this.onCellPreparedCallBack,
              selectionMode: "multiple",
              allowSelectAll: true,
              onContentReadyCallBack: this.onContentReadyCallBack,
            },
          },

          toolbar: {
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/bill-of-materials/create",
                clickAction: {},
                buttonLocation: "left",
                disabled: !FeatureStorage.checkPermission(
                  "BillOfMaterial",
                  "create",
                ),
              },
              {
                icon: "more",
                widget: "dxDropDownButton",
                label: "",
                clickAction: {},
                buttonLocation: "right",
                options: {
                  icon: "more",
                  showArrowIcon: false,
                  keyExpr: "menuText",
                  displayExpr: "menuText",
                  dropDownOptions: { width: 200 },
                  items: [
                    {
                      menuText: "Material Substitution",
                    },
                    {
                      menuText: "Update Linked Planning BOMs",
                    },
                  ],
                  onItemClick: this.onHeaderOptionsMenuItemClick,
                  // disabled: !this.isSubstitutionEnabled,
                  onButtonClick: (e) => {
                    if (e) {
                      const items = e.component.option("items");
                      const index = items.findIndex(
                        (i) => i.menuText === "Material Substitution",
                      );
                      if (index !== -1) {
                        e.component.option(
                          `items[${index}].disabled`,
                          !this.isSubstitutionEnabled,
                        );
                      }
                    }
                  },
                },
              },
            ],
          },
          columns: [
            {
              screenField: "BOM",
              filterIndex: 1,
              dataType: "string",
              type: "Text",
              allowHiding: false,
              filterDataField: "BomSearchText",
              gridDataField: "BomCode",
              sortIndex: 0,
              sortOrder: "asc",
              cellTemplate: (data, info) => {
                return (data.innerHTML = ` <div class="gc-grid-item-container-bom custom-auto-complete">
                  <div>
                  <span class="gc-grid-description">
                      ${info.data.BomDescription}
                    </span>
                    <span class="record-secondary gc-grid-code"> ${
                      info.data.BomCode
                    }</span>
                    </div>
                    <div>
                        ${
                          info.data.IsPrimaryProductionBOM == "Y" ||
                          info.data.IsPrimaryPlanningBOM == "Y"
                            ? `<span class="dx-icon dx-icon-info"></span>`
                            : ""
                        }
                      </div>
                  </div>`);
              },
            },
            {
              screenField: "Product",
              label: "Primary Product",
              filterLabel: "Primary Product",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "PrimaryProductDescription",
                  },
                ],
                secondary: [
                  {
                    dataField: "PrimaryProductCode",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "PrimaryProductCode",
                  label: "Primary Product Code",
                },
                {
                  dataField: "PrimaryProductDescription",
                  label: "Primary Product Description",
                },
              ],
              filterIndex: 2,
              filterDataField: "PrimaryProductCode",
              filterOverWrites: {
                filter: [
                  ["Inactive", "=", "N"],
                  "and",
                  ["Status", "=", "A"],
                  "and",
                  ["Source", "=", "M"],
                ],
              },
            },

            {
              screenField: "Product",
              filterLabel: "Material",
              filterIndex: 3,
              filterDataRelationship: "Comma",
              filterOperator: "contains",
              filterDataField: this.materialFilterField,
              gridDataField: this.materialFilterField,
              showInColumnChooser: false,
              visible: false,
            },
            {
              screenField: "Branch",
              width: ColumnWidth.Branch.width,
              maxWidth: ColumnWidth.Branch.width,
              filterIndex: 4,
            },
            {
              screenField: "Division",
              width: ColumnWidth.Division.width,
              maxWidth: ColumnWidth.Division.width,
              filterIndex: 5,
              filterOverWrites: {
                filter: [["ManufactureFlag", "=", "Y"]],
              },
            },
            {
              screenField: "BOMType",
              dataField: "BomTypeCode",
              width: 120,
              filterIndex: 6,
              filterLabel: "BOM Type",
            },
            {
              screenField: "PrimaryProductionBOM",
              visible: false,
              showInColumnChooser: false,
              filterIndex: 7,
              isMultiValue: false,
              isYesNo: true,
            },
            {
              screenField: "PrimaryPlanningBOM",
              cssClass: "primary-planning-bom-column",
              visible: false,
              showInColumnChooser: false,
              filterIndex: 8,
              isMultiValue: false,
              isYesNo: true,
            },
            {
              screenField: "Status",
              width: "auto",
              filterIndex: 9,
              //   cellTemplate: "Status",
              filterDataField: "Status",
              dataSourceConfig: {
                data: [
                  { key: "A", value: "Active" },
                  { key: "X", value: "Inactive" },
                ],
              },
              valueExpr: "key",
              displayExpr: "value",
              filterDefaultValue: ["A"],
            },
            {
              screenField: "DistinctProductionUM",
              filterIndex: 10,
              showInColumnChooser: false,
              visible: false,
            },
            {
              screenField: "DistinctProductionUMConversion",
              filterIndex: 11,
              showInColumnChooser: false,
              visible: false,
            },
            {
              screenField: "ProductCategory1",
              label: "Category 1",
              filterLabel: "Category 1",
              filterIndex: 12,
              visible: false,
              showInColumnChooser: false,
            },
            {
              screenField: "ProductCategory2",
              label: "Category 2",
              filterLabel: "Category 2",
              filterIndex: 13,
              visible: false,
              showInColumnChooser: false,
            },
            {
              screenField: "ProductCategory3",
              label: "Category 3",
              filterLabel: "Category 3",
              filterIndex: 14,
              visible: false,
              showInColumnChooser: false,
            },
            {
              screenField: "ProductCategory4",
              label: "Category 4",
              filterLabel: "Category 4",
              visible: false,
              showInColumnChooser: false,
              filterIndex: 15,
            },
            {
              screenField: "ProductType",
              name: "ProductType",
              label: "Type",
              filterLabel: "Type",
              filterIndex: 16,
              visible: false,
              showInColumnChooser: false,
            },
          ]
            .concat(this.getAttributeColumns(17))
            .concat(
              {
                screenField: "GridRecordPDFView",
                cssClass: "padding-7",
              },
              {
                screenField: "GridRecordPrint",
                cssClass: "padding-7",
                ReferenceNoField: "BomCode",
              },
              {
                screenField: "GridRecordEllipsisMenu",
                cssClass: "padding-7",
                width: 50,
                allowSearch: false,
                ellipsisMenu: {
                  itemAction: (data) => {
                    var items = [
                      {
                        menuText: "Copy BOM Only",
                        data: data,
                        clickAction: this.onClickCopyBOM,
                        disabled: !FeatureStorage.checkPermission(
                          "BillOfMaterial",
                          "create",
                        ),
                      },
                      {
                        menuText: "Copy BOM & Product",
                        data: data,
                        clickAction: this.onClickCopyBOMProduct,
                        disabled: !FeatureStorage.checkPermission(
                          "BillOfMaterial",
                          "create",
                        ),
                      },
                      {
                        menuText: "Update linked Planning BOM",
                        data: data,
                        clickAction: this.onClickUpdateLinkedPlanningBOM,
                        visible:
                          data.data.BomTypeCode === "Production" &&
                          data.data.IsPrimaryProductionBOM === "Y"
                            ? true
                            : false,
                        disabled: !FeatureStorage.checkPermission(
                          "BillOfMaterial",
                          "create",
                        ),
                      },
                    ];

                    return items;
                  },
                  keyExpr: "menuText",
                  displayExpr: "menuText",
                },
                makeDisabled: (data) => {
                  if (!data) return true;
                  else {
                    const line = data.data;
                    if (line) {
                      if (line.Status === "X") {
                        return true;
                      } else {
                        return false;
                      }
                    }
                  }
                },
              },
            ),
        },
      };

      return config;
    },
    isSubstitutionEnabled() {
      return (
        FeatureStorage.checkPermission("BillOfMaterial", "create") &&
        this.visibleRowCount > 0 &&
        getFilteredValueByKey(this.$refs, "bom-list", this.materialFilterField)
          .length === 1
      );
    },

    gcPopupConfig() {
      return {
        title: "Material Substitution",
        dataModel: this.substituteModel,
        callBack: this.gcPopupCallBack,
        gcPopupVisible: this.gcPopupVisible,
        height: 100,
        formOptions: {
          gcLabelLocation: "left",
        },
        items: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                screenField: "Product",
                dataField: "MaterialCode",
                label: {
                  text: "Original Material",
                },
                displayExpr: (item) => {
                  if (item) return item.Code + " - " + item.Description1;
                  else return "";
                },
              },
              {
                screenField: "Product",
                dataField: "NewMaterialCode",
                label: {
                  text: "Replacement Material",
                },
                displayExpr: (item) => {
                  if (item) return item.Code + " - " + item.Description1;
                  else return "";
                },
                searchExpr: ["Code", "Description1"],
                editorOptions: {
                  allowUpdate: true,
                  showClearButton: true,
                  onValueChanged: (e) => {
                    this.onChangeNewMaterialCode(e);
                  },
                },
                filter: [
                  ["Code", "<>", `${this.substituteModel.MaterialCode}`],
                ],
                required: true,
              },
            ],
          },
        ],
        save: {
          text: "Update",
          clickCallback: (e) => {
            this.onGcPopUpUpdate(e);
          },
          // disabled: !this.NewMaterialUpdated,
        },
        back: {
          text: "Cancel",
          clickCallback: () => {
            this.gcPopupCallBack();
          },
        },
      };
    },
  },
  methods: {
    onChangeNewMaterialCode(e) {
      this.substituteModel["NewMaterialCode"] = e.value;

      // if (e.value) {
      //   this.NewMaterialUpdated = true;
      // } else {
      //   this.NewMaterialUpdated = false;
      // }
    },
    onCellPreparedCallBack(e) {
      // Removed header checkbox conditional as per the new requirement for BOM selection for "Update Linked Planning BOMs" action.
      // if (e.rowType === "header") {
      //   if (e.column.command === "select") {
      //     if (e.cellElement && e.cellElement.classList) {
      //       e.cellElement.classList.add("gc-remove-selection");
      //       const self = this;
      //       on(e.cellElement, "mouseover", (arg) => {
      //         self.$refs[self.tooltipHeaderSelectRef].instance.show(arg.target);
      //       });
      //       on(e.cellElement, "mouseout", () => {
      //         self.$refs[self.tooltipHeaderSelectRef].instance.hide();
      //       });
      //     }
      //   }
      // }

      if (e.rowType === "data") {
        const self = this;

        if (
          e.column.dataField === "BomCode" &&
          e.data.IsPrimaryProductionBOM == "Y"
        ) {
          on(e.cellElement, "mouseover", (arg) => {
            self.$refs[this.tooltipPrimaryProductionRef].instance.show(
              arg.target,
            );
          });

          on(e.cellElement, "mouseout", () => {
            self.$refs[this.tooltipPrimaryProductionRef].instance.hide();
          });
        }
        if (
          e.column.dataField === "BomCode" &&
          e.data.IsPrimaryPlanningBOM == "Y"
        ) {
          on(e.cellElement, "mouseover", (arg) => {
            self.$refs[this.tooltipPrimaryPlanningRef].instance.show(
              arg.target,
            );
          });

          on(e.cellElement, "mouseout", () => {
            self.$refs[this.tooltipPrimaryPlanningRef].instance.hide();
          });
        }
      }
    },
    displayServerErrorOnTemplate(err, msg) {
      this.$store.dispatch("ui/setServerError", {
        error: err,
        title: msg,
      });
    },
    rowClickCallBack(e) {
      if (
        e.rowType == "data" &&
        e.column.screenField != "Status" &&
        e.column.screenField != "GridRecordPDFView" &&
        e.column.screenField != "GridRecordPrint" &&
        e.column.screenField != "GridRecordEllipsisMenu" &&
        e.column.type !== "selection"
      ) {
        // Handle row click event
        this.onRowClicked(e, {
          view: this,
          page: "bill-of-materials",
          mode: "review",
          idProperty: "BomCode",
        });
      }
    },
    setCopyBOMVisible(val) {
      this.CopyBOMVisible = val;

      if (!val) {
        this.popUpConfig = {};
      }
    },
    onClickCopyBOM(data) {
      this.popUpConfig = {
        BillNo: data.BomCode,
        BillType: data.BomTypeCode,
        Description1: data.BomDescription1,
        Description2: data.BomDescription2,
        CopyType: "BOMOnly",
      };

      this.setCopyBOMVisible(true);
    },

    onClickCopyBOMProduct(data) {
      this.popUpConfig = {
        BillNo: data.BomCode,
        BillType: data.BomTypeCode,
        Description1: data.BomDescription1,
        Description2: data.BomDescription2,
        CopyType: "BOMAndProduct",
        ProductCode: data.PrimaryProductCode,
      };

      this.setCopyBOMVisible(true);
    },

    refreshList(refresh = false) {
      this.$refs["bom-list"].$refs["transactionListGrid"].gridRefresh(refresh);
    },

    /**
     * When user clicks on "Update linked Planning BOM" action, system will check if there is a linked Planning BOM for the Production BOM.
     * If there is, system will ask for confirmation to update the linked Planning BOM with the details of the Production BOM. If user confirms,
     * system will call API to update the linked Planning BOM.
     * @param {Object} data - The data of the selected Production BOM record.
     **/
    async onClickUpdateLinkedPlanningBOM(data) {
      if (!data) return;
      if (
        data.ProductPrimaryPlanningBomCode == null ||
        data.ProductPrimaryPlanningBomCode == undefined ||
        !data.ProductPrimaryPlanningBomCode
      ) {
        await this.$alert(
          "No linked Planning BOM found for this Production BOM.",
          "No Linked Planning BOM",
        );
        return;
      }

      const confirm = await this.$confirm(
        "Are you sure you want to update the linked Planning BOM ?",
        "Confirm Update",
      );

      if (confirm) {
        const payload = [
          {
            SourceBomCode: data.BomCode,
            NewBomCode: data.ProductPrimaryPlanningBomCode,
            BillType: "Planning",
            Description1: data.BomDescription1,
            Description2: data.BomDescription2,
            OverwriteTargetBom: true,
          },
        ];
        await this.updateLinkedPlanningBOM(payload);
      }
    },

    /**
     *  This method is used to update the linked Planning BOM with the details of the Production BOM.
     * It calls the API to update the linked Planning BOM and shows a notification message based on the response.
     *  If the update is successful, it refreshes the list to show the updated details.
     * @param payload - The payload containing the details of the Production BOM and the linked Planning BOM to be updated.
     */
    async updateLinkedPlanningBOM(payload, deselect = false) {
      this.setLoading = true;
      try {
        const response = await BillOfMaterialsService.saveCopyBomList(payload);

        if (response)
          this.$notify("Linked Planning BOM updated successfully.", "success");
        this.refreshList(true);
        if (deselect) {
          this.deselectSelectedRows();
        }
      } catch (error) {
        this.setLoading = false;
        this.displayServerErrorOnTemplate(
          error,
          "An error occurred while updating the linked Planning BOM. Please try again.",
        );
      } finally {
        this.setLoading = false;
      }
    },

    /**
     * This method is used to deselect all the selected rows in the grid.
     * It is called after updating the linked Planning BOM to ensure that the user has a clear view of the updated records without any previous selections.
     */
    deselectSelectedRows() {
      const grid = this.$refs["bom-list"].$refs.transactionListGrid;
      if (!grid) {
        return;
      }

      const gridInstance = grid.getDataSourceInstance();
      gridInstance.deselectAll();
    },

    onContentReadyCallBack(e) {
      setTimeout(() => {
        const gridInstance = e.component;
        const visibleRows = gridInstance.getVisibleRows();
        this.visibleRowCount = visibleRows.length;

        // if (this.isSubstitutionEnabled) {
        //   document.querySelectorAll(".gc-remove-selection").forEach((el) => {
        //     el.classList.remove("gc-remove-selection");
        //   });
        // }
      }, 100);
    },

    /**
     * This method is the click handler for the header options menu items. It checks which menu item was clicked and calls the corresponding method to handle the action.
     * @param e The event object containing information about the clicked menu item.
     */
    onHeaderOptionsMenuItemClick(e) {
      const itemData = e.itemData;
      let selectedRows =
        this.$refs["bom-list"].$refs["transactionListGrid"].selectedRowData();

      if (itemData.menuText === "Material Substitution") {
        this.onBOMMaterialSubstitutionClicked(selectedRows);
      } else if (itemData.menuText === "Update Linked Planning BOMs") {
        if (selectedRows.length === 0) {
          this.$alert(
            "Please select one or more BOM records to perform update linked Planning BOMs action.",
            "No Records Selected",
          );
        } else {
          // Check all the selected BOMs are type "Production" or not
          // Also the selected BOM should be IsPrimaryProductionBOM = "Y" as per the business requirement for this action. If any of the selected BOM does not meet this criteria, show alert to user and do not proceed with the action.
          const ifAnyNonProductionBOM = selectedRows.some(
            (row) => row.BomTypeCode !== "Production" || row.IsPrimaryProductionBOM !== "Y",
          );

          if (ifAnyNonProductionBOM) {
            this.$alert(
              "One or more selected BOM records are not Primary Production BOMs. Please select only Primary Production BOMs to perform this action.",
              "Invalid BOM Type Selected",
            );
            return;
          }

          const ifAnyProductionBOMWithoutLinkedPlanningBOM = selectedRows.some(
            (row) =>
              !row.ProductPrimaryPlanningBomCode &&
              row.BomTypeCode === "Production" &&
              row.IsPrimaryProductionBOM === "Y",
          );

          if (ifAnyProductionBOMWithoutLinkedPlanningBOM) {
            this.$alert(
              "One or more selected Production BOM records do not have a linked Planning BOM. <br />Please make sure all selected Production BOMs have linked Planning BOMs before performing this action.",
              "Unlinked Planning BOM Found",
            );
            return;
          }

          this.$confirm(
            "Are you sure you want to update the linked Planning BOMs for the selected Production BOMs ?",
            "Confirm Update",
          ).then((confirm) => {
            if (confirm) {
              const payload = selectedRows.map((row) => ({
                SourceBomCode: row.BomCode,
                NewBomCode: row.ProductPrimaryPlanningBomCode,
                BillType: "Planning",
                Description1: row.BomDescription1,
                Description2: row.BomDescription2,
                OverwriteTargetBom: true,
              }));
              this.updateLinkedPlanningBOM(payload, true);
            }
          });
        }
      }
    },

    async onBOMMaterialSubstitutionClicked(selectedRows) {
      if (selectedRows.length === 0) {
        await this.$alert(
          "Please select one or more BOM records to perform material substitution.",
          "No Records Selected",
        );
      } else {
        this.substituteModel = {
          MaterialCode: undefined,
        };
        const material = getFilteredValueByKey(
          this.$refs,
          "bom-list",
          this.materialFilterField,
        );
        this.substituteModel.MaterialCode = material.length
          ? material[0]
          : null;

        this.$nextTick(() => {
          this.gcPopupVisible = true;
        });
      }
    },

    gcPopupCallBack() {
      this.gcPopupVisible = false;
    },

    async onGcPopUpUpdate() {
      let selectedRows =
        this.$refs["bom-list"].$refs["transactionListGrid"].selectedRowData();

      if (selectedRows.length === 0) {
        await this.$alert(
          "Please select one or more BOM records to perform material substitution.",
          "No Records Selected",
        );

        return;
      }

      const payload = {
        SourceMaterialCode: this.substituteModel.MaterialCode,
        ReplacementMaterialCode: this.substituteModel.NewMaterialCode,
        BomCodes: selectedRows.map((row) => row.BomCode),
      };

      this.setLoading = true;
      try {
        const response = await BillOfMaterialsService.updateMaterialSubstitute(
          payload,
        );

        if (response && response.data) {
          this.$notify(response.data.SuccessMessage, "success");
        }
        this.NewMaterialUpdated = false;
        this.setLoading = false;

        this.$nextTick(() => {
          this.refreshList(true);
          this.gcPopupCallBack();
        });
      } catch (error) {
        this.setLoading = false;
        this.displayServerErrorOnTemplate(
          error,
          "An error occurred while updating material substitution. Please try again.",
        );
      }
    },
  },

  created() {},
};
</script>

<style lang="scss">
.gc-grid-item-container-bom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  .dx-icon {
    color: orange;
  }
}

.bill-of-materials-list {
  // .gc-remove-selection {
  //   cursor: not-allowed;
  //   pointer-events: none !important;
  //   .dx-checkbox.dx-select-checkbox {
  //     pointer-events: none !important;
  //   }

  //   .dx-widget.dx-checkbox.dx-select-checkbox {
  //     opacity: 0.1;
  //   }
  // }
}
</style>
